/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "./Base"

const EyeSlash = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 30 22">
    <svg width="30px" height="22px" viewBox="0 0 30 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="1.-Add-new-survey" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Add-new-Custom-Survey---Step-2,-Pulse-surveys,-All-steps,-Desktop" transform="translate(-1172.000000, -999.000000)" stroke="#636363" strokeWidth="2">
          <g id="Group-4" transform="translate(145.000000, 470.000000)">
            <g id="Group-119" transform="translate(26.000000, 504.000000)">
              <g id="basic_eye_closed" transform="translate(1003.000000, 26.000000)">
                <path d="M0,10.2142857 C0,10.2142857 4.61290323,16.7142857 13,16.7142857 C21.3870968,16.7142857 26,10.2142857 26,10.2142857 C26,10.2142857 21.3870968,3.71428571 13,3.71428571 C4.61290323,3.71428571 0,10.2142857 0,10.2142857 Z" id="Path" />
                <circle id="Oval" cx="13" cy="10.2142857" r="2.78571429" />
                <path d="M3.71428571,19.5 L23.2142857,0" id="Path" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </BaseSvgIcon>
)


export default EyeSlash
